import React from 'react';

import { Alert, Box, Stack, Typography } from '@mui/material';

import ExpandableJsonDetails from './ExpandableJsonDetails';
import type { ExtranetReplayFailure } from './extranetReplayErrors/types';

interface Props {
  failures: Array<ExtranetReplayFailure>;
  onClose?: () => void;
  title?: string;
}

export default function ReplayFailureAlert({ failures, onClose, title = 'Approval failed' }: Props) {
  if (failures.length === 0) {
    return null;
  }

  return (
    <Alert severity="error" onClose={onClose} sx={{ mb: 2 }}>
      <strong>{title}</strong>
      {failures.length === 1 ? (
        <Box component="p" sx={{ m: 0, mt: 0.5 }}>
          {failures[0].agentMessage}
        </Box>
      ) : (
        <Stack component="ul" spacing={0.75} sx={{ m: 0, mt: 0.75, pl: 2 }}>
          {failures.map((failure, index) => (
            <Typography key={`${failure.agentMessage}-${index}`} component="li" variant="body2">
              {failure.agentMessage}
            </Typography>
          ))}
        </Stack>
      )}
      {failures.map((failure, index) => (
        <ExpandableJsonDetails
          key={`${failure.replayCode ?? 'failure'}-${index}`}
          detail={failure.replayDetail}
          testId={failures.length === 1 ? 'replay-technical-details' : `replay-technical-details-${index}`}
          toggleLabel={failures.length === 1 ? 'View technical details' : `View technical details (${index + 1})`}
        />
      ))}
    </Alert>
  );
}
